import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { ADMIN_COMMERCIAL_FEATURES_QUERY_KEY } from '@/state/queries/admin/use-admin-commercial-features-query';
import type { CommercialFeature } from '@/types/dtos/commercial-features/commercial-feature.dto';

export type CreateCommercialFeatureBody = {
  key: string;
  displayName: string;
  description?: string;
  allowedScopeTypes: CommercialFeature['allowedScopeTypes'];
  category?: string;
  deprecated?: boolean;
  replacedByKey?: string;
};

export function useCreateCommercialFeatureMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreateCommercialFeatureBody) => {
      const token = await getToken();
      const res = (await sendJSONRequest({
        url: `${import.meta.env.VITE_API_URL}/commercial-features`,
        method: METHOD.POST,
        body,
        token: token ?? '',
      })) as { feature: Record<string, unknown> };
      return res.feature;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_COMMERCIAL_FEATURES_QUERY_KEY] });
    },
  });
}
